export const THREAD_STATUS_ENUM = {
    PENDING: "Pending",
    INQUEUE: "INQUEUE",
    RUNNING: "Running",
    COMPLETED: "Completed",
    FAILED: "Failed"
};